import { render } from "./document-list.vue?vue&type=template&id=2bff9994&ts=true"
import script from "./document-list.ts?vue&type=script&lang=ts"
export * from "./document-list.ts?vue&type=script&lang=ts"

import "./document-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__